import { Card, CardContent } from "@mui/material";
import { FC, useState } from "react";

import IMAGES from "../../../../assets/themes/images/images";
import styles from "../styles.module.scss";
import config from "../../../../config";

export const assetUrl = (url: string) => {
  if ((url && url?.indexOf("http://") === 0) || url?.indexOf("https://") === 0) {
    const [existingAssetUrl, filePath] = url?.split("/uploads");
    return config.assetUrl + "/uploads" + filePath;
  } else if (url?.indexOf("/") === 0) {
    return config.assetUrl + url;
  }
  return url;
}


const ImageAsset: FC<{ imgUrl: string; title: string }> = ({
  imgUrl,
  title,
}) => {
  const [imgSrc, setImgSrc] = useState<string>(imgUrl);
  const onError = () => setImgSrc(IMAGES.DefaultImg);

  const getFileExtension = (link: string) => {
    const re = /(?:\.([^.]+))?$/;
    return re.exec(link)?.[1];
  };

  const img = imgSrc
    ? getFileExtension(imgSrc) === "pdf"
      ? IMAGES.Pdf
      : assetUrl(imgSrc)
    : IMAGES.DefaultImg;

  return (
    <a href={assetUrl(imgUrl)} target="_blank" rel="noreferrer">
      <Card variant="outlined" className={styles.card}>
        <figure className="avatar avatar-110">
          <img alt={title} src={(img)} onError={onError} />
        </figure>
        <CardContent className={styles.cardContent}>
          <p className="font-size-xs text-truncate">{title}</p>
        </CardContent>
      </Card>
    </a>
  );
};

export default ImageAsset;
